<i
	matTooltipClass="pv-tooltip"
	matTooltipPosition="right"
	[class]="icon"
	[matTooltip]="text"
	[matTooltipDisabled]="disabled"
	[matTooltipShowDelay]="500"
>
</i>
